import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=75982e69&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75982e69",
  null
  
)

export default component.exports